import { ActionMenu } from '@ijoin/components';
import { AdminRkTransactionExportRowRes } from '@ijoin/hooks';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { IconButton } from '@mui/material';

import { FC } from 'react';
import { useToggle } from 'usehooks-ts';

import { RkTransactionExportEditDialog } from './RkTransactionExportEditDialog';

export const RkTransactionExportActionsCell: FC<{
  transactionExport: AdminRkTransactionExportRowRes;
}> = props => {
  const [isEditOpen, toggleEditOpen] = useToggle();

  return (
    <>
      <ActionMenu
        actions={[{ content: 'Edit', onSelect: toggleEditOpen }]}
        trigger={
          <IconButton data-testid={`actions-${props.transactionExport.id}`}>
            <MoreVertIcon />
          </IconButton>
        }
      />
      {isEditOpen && (
        <RkTransactionExportEditDialog
          onClose={toggleEditOpen}
          transactionExport={props.transactionExport}
        />
      )}
    </>
  );
};

RkTransactionExportActionsCell.displayName = 'RkTransactionExportActionsCell';
